import React, { useState } from 'react'
import './Sidebar.css'
import { Navbar, Nav, Container, Row, Col } from 'react-bootstrap'
import HomeIcon from '../../assets/home-icon.png'
import BuildingIcon from '../../assets/building-icon.png'
import SettingIcon from '../../assets/settings-icon.png'
import BuildingInfoIcon from '../../assets/building-info-icon.png'
import NewBuildingView from '../../assets/new-building-view.png'
import ROUTES from "../../../utils/constants/endpoints";

function Sidebar() {
  const activePagePaths = {
    [ROUTES.DASHBOARD]: 'Home',
    [ROUTES.BUILDINGS]: 'Buildings',
    [ROUTES.SETTINGS]: 'Settings',
    [ROUTES.ALTERNATE_VIEW]: 'AlternateView',
    [ROUTES.NEW_ALTERNATE_VIEW]: 'NewAlternateView',
  }

  const [activeIcon, setActiveIcon] = useState(
    activePagePaths[window.location.pathname],
  )

  const toggleOpacity = name => {
    setActiveIcon(name)
  }

  return (
    <Col className='sidebar'>
      <Navbar expand='lg' className='flex-column align-items-center'>
        <Nav className='flex-column'>
          <div className='nav-icon-container'>
            <Nav.Link
              href={ROUTES.DASHBOARD}
              className='nav-link'
              onClick={() => toggleOpacity('Home')}
            >
              <img
                src={HomeIcon}
                alt='Home Icon'
                className={activeIcon === 'Home' ? 'active' : null}
              />
            </Nav.Link>
          </div>
          <div className='nav-icon-container'>
            <Nav.Link
                href={ROUTES.NEW_ALTERNATE_VIEW}
                className='nav-link'
                onClick={() => toggleOpacity('NewAlternateView')}
            >
              <img
                  src={NewBuildingView}
                  alt='Settings Icon'
                  className={activeIcon === 'NewAlternateView' ? 'active' : null}
              />
            </Nav.Link>
          </div>
          <div className='nav-icon-container'>
            <Nav.Link
              href={ROUTES.BUILDINGS}
              className='nav-link'
              onClick={() => toggleOpacity('Buildings')}
            >
              <img
                src={BuildingIcon}
                alt='Building Icon'
                className={activeIcon === 'Buildings' ? 'active' : null}
              />
            </Nav.Link>
          </div>
          <div className='nav-icon-container'>
            <Nav.Link
              href={ROUTES.SETTINGS}
              className='nav-link'
              onClick={() => toggleOpacity('Settings')}
            >
              <img
                src={SettingIcon}
                alt='Settings Icon'
                className={activeIcon === 'Settings' ? 'active' : null}
              />
            </Nav.Link>
          </div>
          <div className='legacy-section'>
            <span className='legacy-title'>Legacy</span>
            <hr className='sidebar-divider' />
          </div>
          <div className='nav-icon-container'>
            <Nav.Link
              href={ROUTES.ALTERNATE_VIEW}
              className='nav-link'
              onClick={() => toggleOpacity('AlternateView')}
            >
              <img
                src={BuildingInfoIcon}
                alt='Settings Icon'
                className={activeIcon === 'AlternateView' ? 'active' : null}
              />
            </Nav.Link>
          </div>
        </Nav>
      </Navbar>
    </Col>
  )
}

export default Sidebar
